import { navLinks, zones } from "@/mocks/homeContent";

export default function FooterBar() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="container-x py-12 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <a href="#top" className="inline-flex items-center gap-2">
              <span className="font-heading flex h-9 items-center rounded-md bg-primary-500 px-2 text-lg font-black text-background-50">
                69黑料
              </span>
            </a>
            <p className="mt-4 text-[13px] leading-relaxed text-foreground-500">
              深挖帖扒皮现场，黑历史起底与深扒全程记录。把公开线索整理成可复盘的主线，持续更新内幕与细节。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-youtube-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="关注渠道"
                  className="flex h-8 w-8 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-500 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="flex items-center gap-1.5 text-sm font-bold text-foreground-950">
              <i className="ri-grid-fill text-primary-500" /> 栏目导航
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-[13px] text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-1.5 text-sm font-bold text-foreground-950">
              <i className="ri-archive-2-line text-accent-600" /> 起底专区
            </h4>
            <ul className="mt-4 space-y-2.5">
              {zones.map((z) => (
                <li key={z.name}>
                  <a
                    href="#zones"
                    className="text-[13px] text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {z.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-1.5 text-sm font-bold text-foreground-950">
              <i className="ri-information-line text-primary-500" /> 关于本站
            </h4>
            <p className="mt-4 text-[13px] leading-relaxed text-foreground-500">
              69黑料定位于公开网络信息的内容整理与归档，不采编未经核实的隐私素材。还原结论依据已公开线索动态修正。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {["关于我们", "信息说明", "内容纠错", "联系方式"].map((t) => (
                <span
                  key={t}
                  className="cursor-pointer rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © 2026 69黑料 · 内容基于公开网络信息整理，仅供信息参考，不代表本站立场。
          </p>
          <p className="inline-flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-shield-check-line" />
            演示站点 · 仅静态展示
          </p>
        </div>
      </div>
    </footer>
  );
}